import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { FaIconSharedModule } from '../../atoms/fa.icon/fa.icon.module';
import { NavDropdownSharedComponent } from './nav.dropdown.component';
import { ClickOutsideSharedDirectiveModule } from '../../../shared/directive/click.outside/click.outside.module';

@NgModule({
    declarations: [
        NavDropdownSharedComponent
    ],
    imports: [
        CommonModule,
        FaIconSharedModule,
        RouterModule.forChild([]),
        ClickOutsideSharedDirectiveModule
    ],
    exports: [
        NavDropdownSharedComponent
    ]
})

// tslint:disable-next-line:no-unnecessary-class
export class NavDropdownSharedModule {}
